import {
    IS_ADD_NEW_OFFERING_FORM_COLLAPSE_OPEN,
    IS_CONNECTIVITY_CONFIG_FORM_VALID,
    IS_NOTE_BEING_ADDED,
    IS_VIEW_ADDING_NEW_COMMUNICATION,
    TOGGLE_ASSIGN_MODAL,
    TOGGLE_ASSIGN_MODAL_DROPDOWN,
    TOGGLE_CONNECTIVITY_CALENDAR_VISABILITY,
    TOGGLE_CONNECTIVITY_CONFIG_FORM_VALID,
    TOGGLE_CONNECTIVITY_MODAL,
    TOGGLE_CONNECTIVITY_MODAL_PARTNER_DROPDOWN,
    TOGGLE_CONNECTIVITY_MODAL_PRACTICE_DROPDOWN,
    TOGGLE_CONNECT_CONFIG_MODAL,
    TOGGLE_CONNECT_CONFIG_MODAL_COLLAPSE,
    TOGGLE_CREATE_PARTNER_MODAL,
    TOGGLE_CREATE_PRACTICE_MODAL,
    TOGGLE_DASHBOARD_VISIBLE,
    TOGGLE_DELETE_SYNC_CONFIRMATION_MODAL,
    TOGGLE_EDIT_FORM_TABLE_IS_EDITING,
    TOGGLE_EDIT_GROUP_FORM_EDITING,
    TOGGLE_EDIT_GROUP_FORM_IS_EDITING,
    TOGGLE_EDIT_PARTNER_FORM_INVALID,
    TOGGLE_EDIT_PARTNER_MODAL,
    TOGGLE_EDIT_PARTNER_MODAL_COLLAPSE,
    TOGGLE_EDIT_PRACTICE_FORM_EDITING,
    TOGGLE_EDIT_TAG_FORM_EDITING,
    TOGGLE_EDIT_TAG_FORM_IS_EDITING,
    TOGGLE_EDIT_USER_FORM_EDITING,
    TOGGLE_EDIT_USER_FORM_IS_EDITING,
    TOGGLE_GETTING_PRACTICE,
    TOGGLE_IGNORE_FAILED_SYNC_MODAL,
    TOGGLE_ASSIGN_USER_TO_PRACTICE_MODAL,
    TOGGLE_IS_PRACTICE_SUMMARY_OPEN,
    TOGGLE_IS_RELATIONS_MODAL_OPEN,
    TOGGLE_NAVBAR_TOGGLER,
    TOGGLE_NEW_GROUP_FORM,
    TOGGLE_NEW_PARTNER_MODAL_COLLAPSE,
    TOGGLE_NEW_PRACTICE_MODAL,
    TOGGLE_NEW_TAG_FORM,
    TOGGLE_NEW_USER_FORM,
    TOGGLE_PENDING_PRACTICE_MODAL,
    TOGGLE_PRACTICE_CONFIG_MODAL,
    TOGGLE_REFRESH,
    TOGGLE_REQUEST_FORM_INVALID,
    TOGGLE_REQUEST_TAB_PARTNER_DROPDOWN,
    TOGGLE_REQUEST_TAB_PRACTICE_DROPDOWN,
    TOGGLE_SYNC_SCHEDULER_IS_EDITING,
    TOGGLE_TAG_CONNECTION_DROPDOWN,
    TOGGLE_TAG_TIER_DROPDOWN,
    TOGGLE_WORKFLOW_CONFIG_MODAL,
    TOGGLE_WORKFLOW_EDIT_PRACTICE_MODAL,
    TOGGLE_WORKFLOW_OFFERING_MODAL,
    TOGGLE_WORKFLOW_SCHEDULE_MODAL,
    TOGGLE_WORKFLOW_SELECT_MODAL,
    TOGGLE_WORKFLOW_TRANSITION,
    USELESS_TOGGLE,
    TOGGLE_SCHEDULE_MODAL,
    TOGGLE_COMMUNICATIONS_TRANSITION,
    TOGGLE_UPDATE_NOTES_MODAL,
    TOGGLE_EDITING_PRACTICE,
    TOGGLE_PRACTICE_REFRESH,
    TOGGLE_REFRESH_ACTIVITIES,
    TOGGLE_SIDEBAR_OPEN,
    TOGGLE_TEXT_PRACTICE_SEARCH,
    TOGGLE_PRACTICE_WORKFLOW_MODAL,
    TOGGLE_EDIT_CONVERSION_PIMS_MODAL,
    TOGGLE_RESET_CONVERSION_MODAL,
    TOGGLE_PLUGIN_DETAIL_MODAL,
    TOGGLE_CONNECT_PLUGIN_DETAIL_MODAL_COLLAPSE,
    TOGGLE_PLUGINOFFERING_ADD_MODAL,
    TOGGLE_PLUGINOFFERING_ADD_MODAL_COLLAPSE,
    TOGGLE_LEADS_GENERATION_CONFIRMATION_MODAL
} from '../ActionTypes';

const initialState = {
    isResetConversionModalOpen: false,
    isEditConversionPimsModalOpen: false,
    isAddNewOfferingFormModalOpen: false,
    isAssignedModalDropDownOpen: false,
    isAssignedModalOpen: {},
    isConnectConfigModalOpen: false,
    isConnectPluginDetailModalOpen: false,
    isConnectivityConfigFormValid: false,
    isConnectivityModalOpen: false,
    isConnectivityModalPartnerDropdownOpen: false,
    isConnectivityModalPracticeDropdownOpen: false,
    isDashboardVisible: false,
    isDeleteSyncConfirmationModalOpen: false,
    isEditGroupFormEditing: false,
    isEditModalOpen: false,
    isEditPartnerFormInvalid: false,
    isEditPartnerModalCollapseOpen: false,
    isEditPartnerModalEditing: false,
    isEditPracticeFormEditing: false,
    isEditTagFormEditing: false,
    isEditUserFormEditing: false,
    isGettingPractice: true,
    isMutePracticeModalOpen: false,
    isAssignUserToPracticeModalOpen: false,
    isNavBarOpen: false,
    isNewGroupFormOpen: false,
    isNewPartnerModalCollapseOpen: false,
    isNewPracticeFormInvalid: false,
    isNewPracticeModalOpen: false,
    isNewTagFormOpen: false,
    isNewUserFormOpen: false,
    isPendingPracticeModalOpen: false,
    isPracticeSummaryOpen: false,
    isRequestFormInvalid: false,
    isRequestTabPartnerDropdownOpen: false,
    isRequestTabPracticeDropdownOpen: false,
    isRelationsModalOpen: false,
    isTagConnectionDropdownOpen: false,
    isTagTierDropdownOpen: false,
    isViewAddingNewCommunication: {},
    isViewAddingNewNote: false,
    toggleConnecivityCalanderVisability: false,
    triggerRefresh: false,
    triggerPracticeRefresh: false,
    triggerActivitiesRefresh: false,
    uselessToggle: false,
    //new workflow
    isWorkflowTransitioning: false,
    isPracticeWorkflowSelectModalOpen: false,
    isPracticeWorkflowEditModalOpen: false,
    isPracticeWorkflowOfferingModalOpen: false,
    isPracticeWorkflowConfigurationModalOpen: false,
    isPracticeWorkflowScheduleModalOpen: false,

    isUpdateNotesModalOpen: false,
    isPracticeScheduleModalOpen: false,

    communicationTransition: false,

    isEditingPractice: false,
    isSidebarOpen: true,
    isSidebarPracticeSearchOpen: false,
    isPracticeWorkflowModalOpen: false,

    isAddNewPluginOfferingModalOpen: false,

    isLeadsGenerationConfirmationModalOpen: false,
};

function toggleReducer(state = initialState, action) {
    let propName = '';
    let changes, isOpenStatus;
    switch (action.type) {
        case TOGGLE_RESET_CONVERSION_MODAL:
            return {
                ...state,
                isResetConversionModalOpen: action.payload,
            };
        case TOGGLE_EDIT_CONVERSION_PIMS_MODAL:
            return {
                ...state,
                isEditConversionPimsModalOpen: action.payload,
            };
        case TOGGLE_NAVBAR_TOGGLER:
            return Object.assign({}, state, {
                isNavBarOpen: action.payload.isOpen,
            });
        case TOGGLE_EDIT_PRACTICE_FORM_EDITING:
            return Object.assign({}, state, {
                isEditPracticeFormEditing: action.payload.isEditing,
            });
        case TOGGLE_ASSIGN_MODAL:
            propName = action.payload.practiceId;
            changes = {};
            changes[propName] = action.payload.status;
            isOpenStatus = { ...state.isAssignedModalOpen, ...changes };
            return {
                ...state,
                isAssignedModalOpen: isOpenStatus,
            };

        //return Object.assign({}, state, {
        //    practiceId: action.payload.practiceId,
        //    isAssignedModalOpen: action.payload.status
        //});
        case TOGGLE_ASSIGN_MODAL_DROPDOWN:
            propName = action.payload.practiceId;
            changes = {};
            changes[propName] = action.payload.status;
            isOpenStatus = { ...state.isAssignedModalDropDownOpen, ...changes };
            return {
                ...state,
                isAssignedModalDropDownOpen: isOpenStatus,
            };
        // return Object.assign({}, state, {
        // isAssignedModalDropDownOpen: action.payload.isOpen,
        // });
        case TOGGLE_PRACTICE_CONFIG_MODAL:
            return Object.assign({}, state, {
                isConnectConfigModalOpen: action.payload,
            });
        case TOGGLE_PLUGIN_DETAIL_MODAL:
            return Object.assign({}, state, {
                isConnectPluginDetailModalOpen: action.payload,
            });
        case TOGGLE_CONNECTIVITY_MODAL:
            return Object.assign({}, state, {
                isConnectivityModalOpen: action.payload.isOpen,
            });
        case TOGGLE_CONNECTIVITY_MODAL_PARTNER_DROPDOWN:
            return Object.assign({}, state, {
                isConnectivityModalPartnerDropdownOpen: action.payload.isOpen,
            });
        case TOGGLE_CONNECTIVITY_MODAL_PRACTICE_DROPDOWN:
            return Object.assign({}, state, {
                isConnectivityModalPracticeDropdownOpen: action.payload.isOpen,
            });
        case TOGGLE_CREATE_PARTNER_MODAL:
            return Object.assign({}, state, {
                isCreatePartnerModalOpen: action.payload.isOpen,
            });
        case TOGGLE_CREATE_PRACTICE_MODAL:
            return Object.assign({}, state, {
                isCreatePracticeModalOpen: action.payload.isOpen,
            });
        case TOGGLE_NEW_PARTNER_MODAL_COLLAPSE:
            return Object.assign({}, state, {
                isNewPartnerModalCollapseOpen: action.payload.isOpen,
            });
        case TOGGLE_EDIT_PARTNER_MODAL:
            return Object.assign({}, state, {
                isEditModalOpen: action.payload.isOpen,
            });
        case TOGGLE_CONNECT_CONFIG_MODAL:
            return Object.assign({}, state, {
                isConnectConfigModalOpen: action.payload.status,
            });
        case TOGGLE_EDIT_PARTNER_MODAL_COLLAPSE:
            return Object.assign({}, state, {
                isEditPartnerModalCollapseOpen: action.payload.isOpen,
            });
        case TOGGLE_EDIT_FORM_TABLE_IS_EDITING:
            return Object.assign({}, state, {
                isEditPartnerModalEditing: action.payload.isOpen,
            });
        case TOGGLE_IS_PRACTICE_SUMMARY_OPEN:
            return Object.assign({}, state, {
                isPracticeSummaryOpen: action.payload.isOpen,
            });
        case TOGGLE_IS_RELATIONS_MODAL_OPEN:
            return Object.assign({}, state, {
                isRelationsModalOpen: action.payload,
            });
        case TOGGLE_CONNECT_CONFIG_MODAL_COLLAPSE:
            return Object.assign({}, state, {
                isConnectConfigModalCollapseOpen: action.payload.isOpen,
            });
        case TOGGLE_CONNECT_PLUGIN_DETAIL_MODAL_COLLAPSE:
            return Object.assign({}, state, {
                isConnectPluginDetailModalCollapseOpen: action.payload.isOpen,
            });
        case TOGGLE_SYNC_SCHEDULER_IS_EDITING:
            return Object.assign({}, state, {
                isSyncSchedulerEditing: action.payload.isEditing,
            });
        case TOGGLE_CONNECTIVITY_CALENDAR_VISABILITY:
            return Object.assign({}, state, {
                toggleConnecivityCalanderVisability: action.payload.isVisable,
            });
        case USELESS_TOGGLE:
            return Object.assign({}, state, {
                uselessToggle: action.payload.toggle,
            });
        case TOGGLE_DELETE_SYNC_CONFIRMATION_MODAL:
            return Object.assign({}, state, {
                isDeleteSyncConfirmationModalOpen: action.payload.isOpen,
            });
        case TOGGLE_EDIT_GROUP_FORM_IS_EDITING:
            // debugger
            return Object.assign({}, state, {
                isEditGroupFormEditing: action.payload.isOpen,
            });
        case TOGGLE_EDIT_GROUP_FORM_EDITING:
            // debugger
            return Object.assign({}, state, {
                isEditGroupFormEditing: action.payload.isEditing,
            });
        case TOGGLE_EDIT_TAG_FORM_IS_EDITING:
            return Object.assign({}, state, {
                isEditTagFormEditing: action.payload.isOpen,
            });
        case TOGGLE_EDIT_TAG_FORM_EDITING:
            return Object.assign({}, state, {
                isEditTagFormEditing: action.payload.isEditing,
            });
        case TOGGLE_EDIT_USER_FORM_IS_EDITING:
            // debugger
            return Object.assign({}, state, {
                isEditUserFormEditing: action.payload.isOpen,
            });
        case TOGGLE_EDIT_USER_FORM_EDITING:
            // debugger
            return Object.assign({}, state, {
                isEditUserFormEditing: action.payload.isEditing,
            });
        case TOGGLE_REQUEST_TAB_PARTNER_DROPDOWN:
            return Object.assign({}, state, {
                isRequestTabPartnerDropdownOpen: action.payload.isOpen,
            });
        case TOGGLE_REQUEST_TAB_PRACTICE_DROPDOWN:
            return Object.assign({}, state, {
                isRequestTabPracticeDropdownOpen: action.payload.isOpen,
            });
        case TOGGLE_TAG_TIER_DROPDOWN:
            return Object.assign({}, state, {
                isTagTierDropdownOpen: action.payload.isOpen,
            });
        case TOGGLE_TAG_CONNECTION_DROPDOWN:
            return Object.assign({}, state, {
                isTagConnectionDropdownOpen: action.payload.isOpen,
            });
        case TOGGLE_NEW_USER_FORM:
            // debugger
            return Object.assign({}, state, {
                isNewUserFormOpen: action.payload.isOpen,
            });
        case TOGGLE_NEW_TAG_FORM:
            // debugger
            return Object.assign({}, state, {
                isNewTagFormOpen: action.payload.isOpen,
            });
        case TOGGLE_NEW_GROUP_FORM:
            return Object.assign({}, state, {
                isNewGroupFormOpen: action.payload.isOpen,
            });
        case TOGGLE_PENDING_PRACTICE_MODAL:
            return Object.assign({}, state, {
                isPendingPracticeModalOpen: action.payload.isOpen,
            });
        case IS_NOTE_BEING_ADDED: {
            propName = action.payload.practiceId;
            changes = {};
            changes[propName] = action.payload.status;
            const newIsAddingNote = {
                ...state.isViewAddingNewNote,
                ...changes,
            };
            return {
                ...state,
                isViewAddingNewNote: newIsAddingNote,
            };
        }
        case TOGGLE_REQUEST_FORM_INVALID:
            return Object.assign({}, state, {
                isRequestFormInvalid: action.payload.invalid,
            });
        case TOGGLE_EDIT_PARTNER_FORM_INVALID:
            return Object.assign({}, state, {
                isEditPartnerFormInvalid: action.payload.invalid,
            });
        case TOGGLE_IGNORE_FAILED_SYNC_MODAL:
            return Object.assign({}, state, {
                isMutePracticeModalOpen: action.payload.isOpen,
            });
        case TOGGLE_ASSIGN_USER_TO_PRACTICE_MODAL:
            return Object.assign({}, state, {
                isAssignUserToPracticeModalOpen: action.payload.isOpen,
            });
        case IS_VIEW_ADDING_NEW_COMMUNICATION: {
            propName = action.payload.practiceId;
            changes = {};
            changes[propName] = action.payload.status;
            const newIsAddingCommunication = {
                ...state.isViewAddingNewCommunication,
                ...changes,
            };
            return {
                ...state,
                isViewAddingNewCommunication: newIsAddingCommunication,
            };
        }
        case IS_CONNECTIVITY_CONFIG_FORM_VALID:
            return {
                ...state,
                isConnectivityConfigFormValid: action.payload,
            };
        case TOGGLE_CONNECTIVITY_CONFIG_FORM_VALID:
            return Object.assign({}, state, {
                isConnectivityConfigFormValid: action.payload,
            });
        case IS_ADD_NEW_OFFERING_FORM_COLLAPSE_OPEN:
            return {
                ...state,
                isAddNewOfferingFormModalOpen: action.payload,
            };
        case TOGGLE_NEW_PRACTICE_MODAL:
            return {
                ...state,
                isNewPracticeModalOpen: action.payload,
            };
        case TOGGLE_DASHBOARD_VISIBLE:
            return {
                ...state,
                isDashboardVisible: action.payload,
            };
        case TOGGLE_REFRESH:
            return {
                ...state,
                triggerRefresh: !state.triggerRefresh,
            };
        case TOGGLE_PRACTICE_REFRESH:
            return {
                ...state,
                triggerPracticeRefresh: !state.triggerPracticeRefresh,
            };
        case TOGGLE_REFRESH_ACTIVITIES:
            return {
                ...state,
                triggerActivitiesRefresh: !state.triggerActivitiesRefresh,
            };
        case TOGGLE_GETTING_PRACTICE:
            return {
                ...state,
                isGettingPractice: action.payload,
            };
        //new workflow stuff
        //transition
        case TOGGLE_WORKFLOW_TRANSITION:
            return {
                ...state,
                isWorkflowTransitioning: action.payload,
            };
        //select practice modal
        case TOGGLE_WORKFLOW_SELECT_MODAL:
            return {
                ...state,
                isPracticeWorkflowSelectModalOpen: action.payload,
            };
        //edit practice modal
        case TOGGLE_WORKFLOW_EDIT_PRACTICE_MODAL:
            return {
                ...state,
                isPracticeWorkflowEditModalOpen: action.payload,
            };
        //offering modal
        case TOGGLE_WORKFLOW_OFFERING_MODAL:
            return {
                ...state,
                isPracticeWorkflowOfferingModalOpen: action.payload,
            };
        //config modal
        case TOGGLE_WORKFLOW_CONFIG_MODAL:
            return {
                ...state,
                isPracticeWorkflowConfigurationModalOpen: action.payload,
            };
        //schedule modal
        case TOGGLE_WORKFLOW_SCHEDULE_MODAL:
            return {
                ...state,
                isPracticeWorkflowScheduleModalOpen: action.payload,
            };
        case TOGGLE_SCHEDULE_MODAL:
            return {
                ...state,
                isPracticeScheduleModalOpen: action.payload,
            };
        case TOGGLE_COMMUNICATIONS_TRANSITION:
            return {
                ...state,
                communicationTransition: action.payload,
            };
        case TOGGLE_UPDATE_NOTES_MODAL:
            return {
                ...state,
                isUpdateNotesModalOpen: action.payload,
            };
        case TOGGLE_EDITING_PRACTICE:
            return {
                ...state,
                isEditingPractice: action.payload,
            };
        case TOGGLE_SIDEBAR_OPEN:
            return {
                ...state,
                isSidebarOpen: action.payload,
            };
        case TOGGLE_TEXT_PRACTICE_SEARCH:
            return {
                ...state,
                isSidebarPracticeSearchOpen: action.payload,
            };
        case TOGGLE_PRACTICE_WORKFLOW_MODAL:
            return {
                ...state,
                isPracticeWorkflowModalOpen: action.payload,
            };
        case TOGGLE_PLUGINOFFERING_ADD_MODAL:
            return Object.assign({}, state, {
                isAddNewPluginOfferingModalOpen: action.payload,
            });
        case TOGGLE_PLUGINOFFERING_ADD_MODAL_COLLAPSE:
            return Object.assign({}, state, {
                isAddNewPluginOfferingModalCollapseOpen: action.payload.isOpen,
            });
        case TOGGLE_LEADS_GENERATION_CONFIRMATION_MODAL:
            return {
                ...state,
                isLeadsGenerationConfirmationModalOpen: action.payload,
            };
        default:
            return state;
    }
}

export default toggleReducer;
